export const DEMO_TARIFF_CODE = 'DEMO_TRIAL';

export interface TariffInfoLike {
  code?: string | null;
  name?: string | null;
  remainingAiCalls?: number | null;
  validUntil?: string | null;
}

export interface TariffOptionModel {
  code: string;
  name: string | null;
  amountKopecks: number | null;
  validityDays: number | null;
  moduleRequests: number | null;
}

export interface TariffPaymentInitModel {
  paymentUrl: string;
  paymentId: string;
}

export function isDemoTariff(code: string | null): boolean {
  if (!code) {
    return false;
  }

  return code.toUpperCase().startsWith(DEMO_TARIFF_CODE);
}

export function toDateKey(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * {@code true}, если период подписки закончился по дате (у любой тариф, включая платный).
 * Не учитывает остаток AI-запросов.
 */
export function isSubscriptionPeriodExpired(tariff: TariffInfoLike | null | undefined): boolean {
  if (!tariff) {
    return false;
  }

  const { validUntil } = tariff;
  return validUntil !== null && validUntil !== undefined && validUntil < toDateKey(new Date());
}

export function isSubscriptionActive(tariff: TariffInfoLike | null | undefined): boolean {
  if (!tariff) {
    return true;
  }

  if (isSubscriptionPeriodExpired(tariff)) {
    return false;
  }

  // Лимит запросов блокирует только демо-тариф: платный тариф с исчерпанными запросами
  // продолжает работать — дополнительные запросы покупаются отдельным пакетом.
  if (isDemoTariff(tariff.code ?? null)) {
    const { remainingAiCalls } = tariff;
    if (remainingAiCalls === null || remainingAiCalls === undefined) {
      return true;
    }
    return remainingAiCalls > 0;
  }

  return true;
}
